import { render } from "./FooterComp.vue?vue&type=template&id=2165792d"
const script = {}

import "./FooterComp.vue?vue&type=style&index=0&id=2165792d&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__